import { render, staticRenderFns } from "./LawMatterBudgetReportBilledExpensesList.vue?vue&type=template&id=60513982&"
import script from "./LawMatterBudgetReportBilledExpensesList.vue?vue&type=script&lang=js&"
export * from "./LawMatterBudgetReportBilledExpensesList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterBudgetReportBilledExpensesList.vue?vue&type=style&index=0&id=60513982&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports